import React from 'react';
import { FaLaptopCode, FaHandHoldingHeart, FaHeadset, FaBook } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const HelpCategories = () => {
  const { t } = useTranslation();

  const categories = [
    {
      id: 1,
      icon: <FaLaptopCode />,
      title: t('helpCategories.categories.0.title'),
      description: t('helpCategories.categories.0.description')
    },
    {
      id: 2,
      icon: <FaHandHoldingHeart />,
      title: t('helpCategories.categories.1.title'),
      description: t('helpCategories.categories.1.description')
    },
    {
      id: 3,
      icon: <FaHeadset />,
      title: t('helpCategories.categories.2.title'),
      description: t('helpCategories.categories.2.description')
    },
    {
      id: 4,
      icon: <FaBook />,
      title: t('helpCategories.categories.3.title'),
      description: t('helpCategories.categories.3.description')
    }
  ];

  return (
    <section className="help-categories" id="help">
      <div className="container">
        <h2 className="section-title">{t('helpCategories.title')}</h2>
        <p className="section-description">{t('helpCategories.description')}</p>
        <div className="categories-grid">
          {categories.map((category) => (
            <article key={category.id} className="category-card">
              <div className="category-icon" aria-hidden="true">
                {category.icon}
              </div>
              <h3 className="category-title">{category.title}</h3>
              <p className="category-description">{category.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HelpCategories;
